import { Button } from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserPlus } from '@fortawesome/free-solid-svg-icons';

export const AdminAddButton = ({ onClick }) => {
  return (
    <Button size="md" className="btn btn-success" onClick={onClick}>
      <FontAwesomeIcon icon={faUserPlus} style={{ fontSize: 16, color: '#fff' }} className="me-3" />
      Agregar usuario
    </Button>
  );
};